import React, { useState } from "react";
import Register from "../../Pages/Registration/Register";
import WelcomePage from "../../Pages/Registration/WelcomePage";
import RegisterForm from "../../Pages/Registration/RegisterForm";
import TermsSignature from "../../Pages/Registration/TermsSignature";
import logo from '../../assets/orevanEventsLogo.png';
import abbottLogo from '../../assets/abbottLogo.png';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGetEventDataById } from "../../hooks/useEvent";

const RegistrationLayout = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [originalDoctorData, setOriginalDoctorData] = useState(null);
  const [values, setValues] = useState({
    event_id: '',
    first_name: '',
    family_name: '',
    national_id: '',
    email: '',
    phone_number: '',
    country_id: '',
    city_id: '',
    specialty: '',
    medical_license: '',
    organization: '',
    signature: '',
    sign64data: '',
    APO_number: '',
    doctor_master_data_id: '',
    industry_area: '',
    updated_at: null,
    created_at: null,
  });

  const { data: eventData } = useGetEventDataById(values.event_id)

  const backgroundColorTheme = currentStep !== 0 && eventData?.bg_color ? eventData.bg_color : "#ffffff";

  return (
    <div
      style={{
        backgroundColor: backgroundColorTheme
      }}
      className="min-h-screen flex flex-col justify-between overflow-y-auto"
      >
      <ToastContainer />
      <div className="flex justify-center mt-10">
        <img className="w-52 lg:w-64" src={abbottLogo} alt="Logo" />
      </div>
      <div className="my-10">
        {currentStep === 0 && <Register values={values} setValues={setValues} setCurrentStep={setCurrentStep} />}

        {currentStep === 1 && <WelcomePage values={values} setValues={setValues} setCurrentStep={setCurrentStep} eventData={eventData} />}

        {currentStep === 2 && <RegisterForm values={values} setValues={setValues} setCurrentStep={setCurrentStep} setOriginalDoctorData={setOriginalDoctorData} eventData={eventData} />}

        {currentStep === 3 && <TermsSignature values={values} setValues={setValues} setCurrentStep={setCurrentStep} originalDoctorData={originalDoctorData} eventData={eventData} />}
      </div>
      <div className="flex justify-center mb-10">
        <img className="w-52 lg:w-64" src={logo} alt="Logo" />
      </div>
    </div>
  );
};

export default RegistrationLayout;
